import { StickyNote } from "lucide-react";
import { NotesPanel } from "@/components/notes/NotesPanel";

export default function NotesPage() {
  return (
    <div className="p-6 lg:p-8" data-testid="notes-page">
      <header className="mb-6">
        <div className="text-[11px] font-semibold uppercase tracking-widest text-slate-500 inline-flex items-center gap-1.5"><StickyNote className="h-3.5 w-3.5" /> Notes</div>
        <h1 className="font-display text-2xl font-bold tracking-tight text-slate-900">Notes</h1>
        <p className="text-sm text-slate-500">Rich documents with headings, colors, tables and images. Admins can see and edit everyone's notes.</p>
      </header>
      <NotesPanel />
    </div>
  );
}
